import { toPositiveInteger } from 'modules/settings/components/custom-notifications/custom-notification-form.validation';
import { NotificationThresholdFormState } from 'modules/settings/components/custom-notifications/custom-notification-threshold.model';

interface NotificationThresholdValue {
    enabled: boolean;
    numberOfEvents?: number;
}

export const toThresholdFormState = ({
    enabled,
    numberOfEvents,
}: NotificationThresholdValue): NotificationThresholdFormState => ({
    enabled,
    numberOfEvents: numberOfEvents ? String(numberOfEvents) : null,
});

export const toThresholdValue = ({
    enabled,
    numberOfEvents,
}: NotificationThresholdFormState): NotificationThresholdValue => ({
    enabled,
    numberOfEvents: toPositiveInteger(numberOfEvents) ?? undefined,
});
